/* eslint-disable */
import React, { useState, useEffect } from "react";
import EditIcon from "@material-ui/icons/Edit";
import { AvForm } from "availity-reactstrap-validation";
import { Button, Alert, Label, Row, Col } from "reactstrap";
import Radio from "@material-ui/core/Radio";
import FormGroup from "@mui/material/FormGroup";
import FormLabel from "@mui/material/FormLabel";
import InfoIcon from "@material-ui/icons/Info";
import IconButton from "@material-ui/core/IconButton";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import Slide from "@mui/material/Slide";
import TextField from "@material-ui/core/TextField";

const Edithost = (props) => {
  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = (e) => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [hostinfo, setHostinfo] = useState([]);
  const [selectedValue, setSelectedValue] = React.useState(props.PROVIDER);

  const handleChange1 = (event) => {
    setSelectedValue(event.target.value);
  };

  useEffect(() => {
    const CloudID = props.CloudID;
    fetch(`${process.env.REACT_APP_API_URL}/api/clouds/${CloudID}/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data.detail) {
          window.localStorage.setItem("user_access", data.detail);
        } else {
          setHostinfo(data);
        }
      })
      .catch((error) => {
        console.error(error);
        window.location.href = "/something_went_wrong";
      });
  }, [props.HostID]);

  const [state, setState] = useState({
    name: "",
    provider: "",
    accountid: "",
    subscriptionid: "",
    tenant: "",
    serviceacc: "",
    credential_id: "",
    domain: "",
    errorMessage: "",
  });

  const handleChange = (e) => {
    const { id, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const handleSubmitClick = (e) => {
    e.preventDefault();
    const host = {
      name: state.name,
      provider: state.provider,
      accountid: state.accountid,
      subscriptionid: state.subscriptionid,
      tenant: state.tenant,
      serviceacc: state.serviceacc,
      credential_id: state.credential_id,
    };
    const CloudID = props.CloudID;
    fetch(`${process.env.REACT_APP_API_URL}/api/clouds/${CloudID}/`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("token"),
      },
      body: JSON.stringify(host),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.id) {
          window.location.reload();
        } else {
          if (data.name) {
            setState({ errorMessage: data.name });
          } else if (data.account) {
            setState({ errorMessage: data.account[0] });
          } else {
            setState({ errorMessage: data.non_field_errors[0] });
          }
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };
  const [focusAfterClose] = useState(true);
  const toggle = () => setOpen(!open);

  const [credlist, setcredlist] = useState([]);
  useEffect(() => {
    const Cloud = props.PROVIDER;
    fetch(`${process.env.REACT_APP_API_URL}/api/organizationcredlistforresource/${Cloud}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((resp) => setcredlist(resp))
      .catch((error) => {
        console.error(error);
        window.location.href = "/something_went_wrong";
      });
  }, []);

  function refreshPage() {
    window.location.reload();
  }
  const isValidDomain1 = require("is-valid-domain");

  return (
    <>
      <IconButton
        title="Edit"
        aria-label="edit"
        id="edit"
        style={{ padding: "0px", color: "#6b6f6b" }}
      >
        <EditIcon fontSize="small" onClick={handleClickOpen} />
      </IconButton>

      <Dialog
        PaperProps={{
          sx: {
            width: "100%",
          },
        }}
        open={open}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent>
          <div className=" modal-header">
            <h2
              style={{
                textAlign: "center",
                fontSize: "18px",
                fontWeight: "810",
                color: "rgb(48, 68, 115)",
                fontFamily: "sans-serif",
                lineHeight: "4.5rem",
              }}
            >
              Edit a Cloud Account
            </h2>
          </div>

          <DialogContentText>
            <div>
              {state.errorMessage && (
                <Alert color="danger"> {state.errorMessage} </Alert>
              )}
            </div>
            <AvForm role="form">
              <FormLabel htmlFor="name">
                <strong>Name</strong>
              </FormLabel>
              <TextField
                type="text"
                id="name"
                className="form-control"
                value={state.name}
                onChange={handleChange}
                placeholder={hostinfo.name}
                variant="outlined"
                size="small"
                fullWidth
              />
              {state.name ? (
                <p>
                  {" "}
                  {/^\S+$/.test(state.hostname) ? null : (
                    <span style={{ color: "red" }}>
                      *Please enter the Name without whitespaces
                    </span>
                  )}
                </p>
              ) : (
                ""
              )}{" "}
              <br />
              <br />
              <FormLabel htmlFor="provider">
                <strong>Provider</strong>
              </FormLabel>              
              <TextField
                className="form-control"
                type="select"
                id="provider"
                name="provider"
                value={state.provider}
                onChange={handleChange}
                placeholder={hostinfo.provider}
                variant="outlined"
                size="small"
                fullWidth
                required
                select
                SelectProps={{ native: true }}
              >
                {" "}
                <option>{hostinfo.provider}</option>
              </TextField>
              <br />       
              <br />       
              {hostinfo.provider == "aws" ? (
                  <React.Fragment>
                    <FormGroup>
                      <FormLabel htmlFor="accountid">
                        <strong>Account ID</strong>
                      </FormLabel>
                      <TextField
                        fullWidth
                        type="text"
                        id="accountid"
                        className="form-control"
                        value={state.accountid}
                        onChange={handleChange}
                        placeholder={hostinfo.accountid}
                        variant="outlined"
                        size="small"
                      />
                    </FormGroup>
                    <br />
                  </React.Fragment>
                ) : hostinfo.provider == "azure" ? (
                  <React.Fragment>
                    <FormGroup>
                      <FormLabel htmlFor="subscriptionid">
                        <strong>Subscription ID</strong>
                      </FormLabel>
                      <TextField
                        fullWidth
                        type="text"
                        id="subscriptionid"
                        className="form-control"
                        value={state.subscriptionid}
                        onChange={handleChange}
                        placeholder={hostinfo.subscriptionid}
                        variant="outlined"
                        size="small"
                      />
                    </FormGroup>
                    <br />
                    <FormGroup>
                      <FormLabel htmlFor="tenant">
                        <strong>Tenant</strong>
                      </FormLabel>
                      <TextField
                        fullWidth
                        type="text"
                        id="tenant"
                        className="form-control"
                        value={state.tenant}
                        onChange={handleChange}
                        variant="outlined"
                        size="small"
                        placeholder={hostinfo.tenant}
                      />
                    </FormGroup>
                    <br />
                  </React.Fragment>
                ) : hostinfo.provider == "gcp" ? (
                  <React.Fragment>
                    <FormGroup>
                      <FormLabel htmlFor="serviceacc">
                        <strong>Service A/C Email Address</strong>
                      </FormLabel>
                      <TextField
                        fullWidth
                        type="text"
                        id="serviceacc"
                        className="form-control"
                        value={state.serviceacc}
                        onChange={handleChange}
                        variant="outlined"
                        size="small"
                        placeholder={hostinfo.serviceacc}
                      />
                    </FormGroup>
                    <br />
                  </React.Fragment>
                ) : (
                  ""
                )}                     
              <br />
              <Row form>
                <FormLabel htmlFor="credential_id" className="ml-2">
                  <strong>Credentials</strong>
                </FormLabel>

                <Col md={12}>
                  <FormGroup>
                    <TextField
                      type="select"
                      id="credential_id"
                      className="form-control"
                      value={state.credential_id}
                      onChange={handleChange}
                      placeholder={hostinfo.credential_id}
                      variant="outlined"
                      size="small"
                      fullWidth
                      select
                      SelectProps={{ native: true }}
                    >
                      {credlist.map((credlist) => {
                        if (parseInt(hostinfo.credential_id) == parseInt(credlist.id)) {
                          return (
                            <React.Fragment>
                              <option value={credlist.id}>
                                {credlist.name}
                              </option>
                            </React.Fragment>
                          );
                        }
                      })}
                      {credlist.map((credlist) => {
                        if (parseInt(hostinfo.credential_id) !== parseInt(credlist.id)) {
                          return (
                            <React.Fragment>
                              <option value={credlist.id}>
                                {credlist.name}
                              </option>
                            </React.Fragment>
                          );
                        }
                      })}
                    </TextField>
                  </FormGroup>
                </Col>
              </Row>
              <br />
            </AvForm>
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button
            className="bg-blueGray-100 text-black font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
            onClick={() => refreshPage()}
          >
            Cancel
          </Button>

          <Button
            className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
            type="submit"
            onClick={handleSubmitClick}
          >
            Update&nbsp;
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
export default Edithost;